import React, { useState } from "react";
import { useLocation } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap'; 
import DynamicForm from '../genericcrud/DynamicForm';
import { User } from "../../models/User";
import PermissionsView from "../permissions/PermissionsView";

const UserProfile = () => {
    const location = useLocation();
    const { currentRow } = location.state || {};
    const [activeTab, setActiveTab] = useState("general");
    
    return (
        <>
            <Tabs
                id="user-profile-tabs"
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
                className="mb-3"
            >
                <Tab eventKey="general" title="General Info">
                    <div className="row justify-content-end my-3">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body p-3">
                                    <DynamicForm
                                        isModel={false}
                                        row={currentRow}
                                        documentMeta={User}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Tab>
                <Tab eventKey="permission" title="Permission">
                    <div className="row justify-content-end my-3">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body p-3">
                                    <PermissionsView />
                                </div>
                            </div>
                        </div>
                    </div>
                </Tab>
            </Tabs>
        </>
    );
};

export default UserProfile;
